/* ============================================================
   Inner Dragon — Cart Drawer Extras · JS v13
   קובץ: assets/ids-cart-extras.js (החלפה מלאה)
   ‼️ זיהוי: זה קובץ הסקריפט — מתחיל ב-(function () {
   v13: אפסייל בפעולה אחת — בחירת מידה מוסיפה לסל מיידית.
   v12: אפסייל — בורר המידה מתחיל ב"מידה" (placeholder) במקום
   בחירה אקראית; לחיצה על הוספה בלי מידה = איתות אדום שקט.
   v11: הסרת קוד קופון — כפתור ✕ על תגית ההנחה (removeCoupon).
   + כל הקודם (v10): אפסייל חכם-פערים, פותחן ביטחון, שומר-סף,
   שומר מתנה, כמות אופטימית.
   ============================================================ */
(function () {
  'use strict';

  var initTimer = null;
  var observer = null;

  /* ───────── עזרים בסיסיים ───────── */

  function getDrawer() {
    return document.querySelector('cart-drawer[data-section-id]');
  }

  function getSectionId() {
    var d = getDrawer();
    return d ? d.getAttribute('data-section-id') : null;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    return '\u20AA' + n; /* ₪ */
  }

  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function setBusy(el, on) {
    if (!el) return;
    el.classList[on ? 'add' : 'remove']('is-busy');
  }

  function setDrawerBusy(on) {
    var d = getDrawer();
    if (d) d.classList[on ? 'add' : 'remove']('ids-busy');
  }

  /* ───────── Cart AJAX API ───────── */

  function cartAdd(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function cartChangeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: qty })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ───────── רענון המגירה מהשרת ───────── */

  function refreshDrawer() {
    var id = getSectionId();
    if (!id) return Promise.resolve();
    return fetch('/?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections[id];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('cart-drawer');
        var current = getDrawer();
        if (!fresh || !current) return;
        /* מחליפים רק את אזור התוכן — כפתור הסגירה והאוברליי
           נשארים אלמנטים מקוריים עם ה-listeners של התבנית */
        var freshContent = fresh.querySelector('.drawer__content');
        var curContent = current.querySelector('.drawer__content');
        /* שמירת מיקום הגלילה של גוף העגלה לאורך הרענון */
        var bodyEl = current.querySelector('.cart-drawer__body');
        var scrollPos = bodyEl ? bodyEl.scrollTop : 0;
        if (freshContent && curContent) curContent.innerHTML = freshContent.innerHTML;
        else current.innerHTML = fresh.innerHTML;
        var newBodyEl = current.querySelector('.cart-drawer__body');
        if (newBodyEl && scrollPos) newBodyEl.scrollTop = scrollPos;
      })
      .then(syncHeader)
      .catch(function () {})
      .then(function () {
        setDrawerBusy(false);
        scheduleInit();
      });
  }

  /* שומר המתנה: מתנה אחת בלבד, בכמות 1 בלבד.
     חוסם הוספה ידנית של מתנות מעמודי המוצר (שורות free_gift
     נסתרות מהעגלה והיו עוברות בחינם לתשלום). */
  var giftGuardBusy = false;

  function enforceGiftRules(cart) {
    if (giftGuardBusy) return;
    var gifts = (cart.items || []).filter(function (it) {
      return it.product_type === 'free_gift';
    });
    if (!gifts.length) return;
    var updates = {};
    var dirty = false;
    gifts.forEach(function (g, i) {
      var want = i === 0 ? 1 : 0; /* שומרים את הראשונה בלבד */
      if (g.quantity !== want) {
        updates[g.id] = want;
        dirty = true;
      }
    });
    if (!dirty) return;
    giftGuardBusy = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () { return refreshDrawer(); })
      .catch(function () {})
      .then(function () { giftGuardBusy = false; });
  }

  /* עדכון ספירת הסל בכותרת + אירועים לתבנית */
  function syncHeader() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        enforceGiftRules(cart);
        var count = cart.item_count;
        var d = getDrawer();
        ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.cart__count',
         '.header__cart-count', '[data-header-cart-count]', '.js-cart-count', '#cart-count'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (d && d.contains(el)) return; /* בתוך המגירה — כבר התרענן */
            el.textContent = count;
            if (count > 0) el.removeAttribute('hidden');
          });
        });
        /* חשוב: לא משדרים 'cart:refresh' — המגירה של Sleek מאזינה לו
           ומרנדרת את עצמה מחדש (רינדור כפול + מרוץ מול הסגירה).
           'cart:updated' בלבד — לבר המשלוח של התבנית ולאפליקציות. */
        var ev = new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, source: 'ids-cart-extras' } });
        document.dispatchEvent(ev);
      })
      .catch(function () {});
  }

  /* ───────── מתנות ───────── */

  function addGift(btn, variantId) {
    setBusy(btn, true);
    setDrawerBusy(true);
    cartAdd(variantId, 1)
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* פתיחת מצב בחירה במקום הכרטיס הנבחר */
  function openGiftSwap(btn) {
    var widget = btn.closest('[data-ids-gift]');
    if (!widget) return;
    var chosenRow = widget.querySelector('[data-ids-gift-chosen-row]');
    var list = widget.querySelector('.ids-gift__list--swap');
    var headChosen = widget.querySelector('[data-ids-gift-head-chosen]');
    var headChoose = widget.querySelector('[data-ids-gift-head-choose]');
    if (chosenRow) chosenRow.setAttribute('hidden', '');
    if (list) list.removeAttribute('hidden');
    if (headChosen) headChosen.setAttribute('hidden', '');
    if (headChoose) headChoose.removeAttribute('hidden');
  }

  /* חזרה מהבחירה לכרטיס הנבחר — בלי שינוי בסל */
  function closeGiftSwap(btn) {
    var widget = btn.closest('[data-ids-gift]');
    if (!widget) return;
    var chosenRow = widget.querySelector('[data-ids-gift-chosen-row]');
    var list = widget.querySelector('.ids-gift__list--swap');
    var headChosen = widget.querySelector('[data-ids-gift-head-chosen]');
    var headChoose = widget.querySelector('[data-ids-gift-head-choose]');
    if (list) list.setAttribute('hidden', '');
    if (chosenRow) chosenRow.removeAttribute('hidden');
    if (headChoose) headChoose.setAttribute('hidden', '');
    if (headChosen) headChosen.removeAttribute('hidden');
  }

  function swapGift(btn, newVariantId) {
    var widget = btn.closest('[data-ids-gift]');
    var changeBtn = widget ? widget.querySelector('[data-ids-gift-change]') : null;
    var currentLine = changeBtn ? changeBtn.getAttribute('data-current-line') : null;
    setBusy(btn, true);
    setDrawerBusy(true);
    var p = currentLine ? cartChangeLine(currentLine, 0) : Promise.resolve();
    p.then(function () { return cartAdd(newVariantId, 1); })
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* מתנה "יתומה" — הסל ירד מתחת ליעד → הסרה אוטומטית */
  function handleOrphanGift() {
    var g = document.querySelector('[data-ids-gift][data-state="orphan"]');
    if (!g || g.getAttribute('data-ids-busy') === '1') return;
    var line = g.getAttribute('data-orphan-line');
    if (!line) return;
    g.setAttribute('data-ids-busy', '1');
    cartChangeLine(line, 0)
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── החלפת מידה בשורת פריט ───────── */

  function swapLineVariant(sel) {
    var line = sel.getAttribute('data-line');
    var item = sel.closest('.cart-item');
    var qty = item ? Number(item.getAttribute('data-quantity')) || 1 : 1;
    var newId = sel.value;
    sel.disabled = true;
    setDrawerBusy(true);
    cartChangeLine(line, 0)
      .then(function () { return cartAdd(newId, qty); })
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── קופון ───────── */

  function toggleCoupon(btn) {
    var wrap = btn.closest('[data-ids-coupon]');
    var form = wrap ? wrap.querySelector('.ids-coupon__form') : null;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (form) {
      if (open) form.setAttribute('hidden', '');
      else {
        form.removeAttribute('hidden');
        /* פוקוס אוטומטי רק בדסקטופ — במובייל זה מקפיץ מקלדת מיד */
        var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        var input = form.querySelector('[data-ids-coupon-input]');
        if (input && fine) input.focus();
      }
    }
  }

  function showCouponMsg(wrap, text, ok) {
    var msg = wrap ? wrap.querySelector('[data-ids-coupon-msg]') : null;
    if (!msg) return;
    msg.textContent = text;
    msg.classList.remove('is-ok', 'is-error');
    msg.classList.add(ok ? 'is-ok' : 'is-error');
    msg.removeAttribute('hidden');
  }

  function applyCoupon(btn) {
    var wrap = btn.closest('[data-ids-coupon]');
    var input = wrap ? wrap.querySelector('[data-ids-coupon-input]') : null;
    var code = input ? (input.value || '').trim() : '';
    if (!code) return;
    setBusy(btn, true);

    /* ניסיון 1: ה-API החדש — מחיל את הקוד ישירות על הסל */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (cart) {
        var codes = cart && cart.discount_codes;
        if (Object.prototype.toString.call(codes) === '[object Array]') {
          var found = null;
          for (var i = 0; i < codes.length; i++) {
            if (String(codes[i].code).toUpperCase() === code.toUpperCase()) found = codes[i];
          }
          if (found && found.applicable) {
            showCouponMsg(wrap, '\u05D4\u05E7\u05D5\u05D3 \u05D4\u05D5\u05E4\u05E2\u05DC', true); /* הקוד הופעל */
            setDrawerBusy(true);
            return refreshDrawer();
          }
          if (found && !found.applicable) {
            setBusy(btn, false);
            showCouponMsg(wrap, '\u05D4\u05E7\u05D5\u05D3 \u05DC\u05D0 \u05EA\u05E7\u05E3 \u05DC\u05E1\u05DC \u05D4\u05E0\u05D5\u05DB\u05D7\u05D9', false); /* הקוד לא תקף לסל הנוכחי */
            return;
          }
        }
        /* ניסיון 2: המנגנון הוותיק — הקוד נשמר בעוגייה ויוחל בצ'קאאוט */
        return fetch('/discount/' + encodeURIComponent(code)).then(function () {
          setBusy(btn, false);
          showCouponMsg(wrap, '\u05D4\u05E7\u05D5\u05D3 \u05E0\u05E9\u05DE\u05E8 \u05D5\u05D9\u05D5\u05D7\u05DC \u05D1\u05E2\u05DE\u05D5\u05D3 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD', true); /* הקוד נשמר ויוחל בעמוד התשלום */
        });
      })
      .catch(function () {
        setBusy(btn, false);
        showCouponMsg(wrap, '\u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9, \u05E0\u05E1\u05D9 \u05E9\u05D5\u05D1', false); /* משהו השתבש, נסי שוב */
      });
  }

  /* הסרת קוד קופון שהוחל — ✕ על תגית ההנחה.
     שולפים את רשימת הקודים הפעילים מהשרת, מסננים את המוסר,
     ושולחים את הנותרים. רשימה ריקה = ניקוי כל הקודים. */
  function removeCoupon(btn) {
    if (btn.classList.contains('is-busy')) return;
    var code = btn.getAttribute('data-ids-coupon-remove');
    if (!code) return;
    setBusy(btn, true);
    setDrawerBusy(true);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var remaining = [];
        (cart.discount_codes || []).forEach(function (c) {
          if (String(c.code).toUpperCase() !== String(code).toUpperCase()) remaining.push(c.code);
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') })
        });
      })
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── תקנון — שער לפני תשלום (רעידה + אדום בלבד) ───────── */


  function onTermsChange(box) {
    try {
      if (box.checked) sessionStorage.setItem(TERMS_KEY, '1');
      else sessionStorage.removeItem(TERMS_KEY);
    } catch (_) {}
    var wrap = box.closest('[data-ids-terms]');
    if (wrap) wrap.classList.remove('is-invalid');
  }

  function guardCheckout(e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-ids-checkout-form]') : null;
    if (!form) return;
    var box = document.querySelector('[data-ids-terms-box]');
    if (!box) return; /* אישור תקנון כבוי בהגדרות */
    if (box.checked) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = box.closest('[data-ids-terms]');
    if (wrap) {
      wrap.classList.remove('is-invalid');
      void wrap.offsetWidth; /* ריסטרט לאנימציה */
      wrap.classList.add('is-invalid');
      wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ───────── אפסייל: השלימי את הלוק ───────── */

  function filterRecs(products, exclude) {
    return (products || []).filter(function (p) {
      return p.available && p.type !== 'free_gift' && exclude.indexOf(String(p.id)) === -1;
    });
  }

  function loadUpsell() {
    var box = document.querySelector('[data-ids-upsell]');
    if (!box || box.getAttribute('data-ids-loaded') === '1') return;
    box.setAttribute('data-ids-loaded', '1');
    var pid = box.getAttribute('data-product-id');
    var limit = Number(box.getAttribute('data-limit')) || 1;
    var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var prods = filterRecs(data.products, exclude);
        if (prods.length) return prods;
        return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) { return filterRecs(d.products, exclude); });
      })
      .then(function (prods) {
        prods = smartOrder(prods, box);
        prods = prods.slice(0, limit);
        if (!prods.length) return;
        var list = box.querySelector('[data-ids-upsell-list]');
        if (!list) return;
        list.innerHTML = prods.map(renderUpsellItem).join('');
        box.removeAttribute('hidden');
        requestAnimationFrame(function () { box.classList.add('is-in'); });
      })
      .catch(function () {});
  }

  /* חכם-פערים: אם חסר סכום ליעד הבא, מקדימים את המוצר הזול
     ביותר שמחירו סוגר את הפער (היעד מושג בפריט אחד). אם אף
     מוצר לא סוגר — הקרוב ביותר. בלי יעד פתוח: הסדר המקורי. */
  function smartOrder(prods, box) {
    if (!prods || prods.length < 2) return prods || [];
    var total = Number(box.getAttribute('data-cart-total')) || 0;
    var gGift = Number(box.getAttribute('data-goal-gift')) || 0;
    var gShip = Number(box.getAttribute('data-goal-ship')) || 0;
    var gap = 0;
    if (gGift && total < gGift) gap = gGift - total;
    else if (gShip && total < gShip) gap = gShip - total;
    if (gap <= 0) return prods;
    var closing = prods.filter(function (p) { return p.price >= gap; });
    var rest = prods.filter(function (p) { return p.price < gap; });
    closing.sort(function (a, b) { return a.price - b.price; });
    rest.sort(function (a, b) { return b.price - a.price; });
    return closing.concat(rest);
  }

  function renderUpsellItem(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var variants = p.variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    var first = avail[0] || variants[0] || null;
    var hasVars = variants.length > 1;
    var selHtml = '';
    if (hasVars) {
      selHtml = '<select class="ids-line-variant__select" data-ids-upsell-variant aria-label="' + esc(p.title) + '">' +
        '<option value="" selected disabled>\u05DE\u05D9\u05D3\u05D4</option>' + /* מידה */
        variants.map(function (v) {
          return '<option value="' + v.id + '"' +
            (v.available ? '' : ' disabled') +
            '>' + esc(v.title) + (v.available ? '' : ' \u2014 \u05D0\u05D6\u05DC') + '</option>'; /* — אזל */
        }).join('') +
        '</select>';
    }
    return '<div class="ids-upsell__item" dir="rtl">' +
      (img ? '<img class="ids-upsell__img" loading="lazy" src="' + esc(imgUrl(img, 120)) + '" alt="' + esc(p.title) + '">' : '') +
      '<div class="ids-upsell__info">' +
        '<span class="ids-upsell__title">' + esc(p.title) + '</span>' +
        '<span class="ids-upsell__price">' + money(p.price) + '</span>' +
        selHtml +
      '</div>' +
      '<button type="button" class="ids-upsell__add" data-ids-upsell-add' +
        (first && !hasVars ? ' data-variant="' + first.id + '"' : '') +
      '>\u05D4\u05D5\u05E1\u05E4\u05D4</button>' + /* הוספה */
    '</div>';
  }

  function addUpsell(btn) {
    var variantId = btn.getAttribute('data-variant');
    var sel = null;
    if (!variantId) {
      var item = btn.closest('.ids-upsell__item');
      sel = item ? item.querySelector('[data-ids-upsell-variant]') : null;
      variantId = sel ? sel.value : null;
    }
    if (!variantId) {
      /* לא נבחרה מידה — מסמנים את הבורר במקום להוסיף מידה אקראית */
      if (sel) {
        sel.classList.remove('ids-sel-invalid');
        void sel.offsetWidth; /* ריסטרט לאנימציה */
        sel.classList.add('ids-sel-invalid');
        try { sel.focus({ preventScroll: true }); } catch (_) {}
      }
      return;
    }
    setBusy(btn, true);
    setDrawerBusy(true);
    cartAdd(variantId, 1)
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── האזנות — delegation, שורד כל רינדור-מחדש ───────── */

  /* ───────── פותחן ביטחון ─────────
     אחרי הוספה לסל המגירה אמורה להיפתח ע"י התבנית. אם השרשרת
     שלה נשברת בשקט — אנחנו פותחים דרך ה-API שלה (show), ורק
     אם פתחנו אנחנו — מרעננים תוכן. אם היא כבר פתוחה: לא נוגעים. */

  function ensureDrawerOpen(withRefresh) {
    var d = getDrawer();
    if (!d || d.hasAttribute('open') || typeof d.show !== 'function') return;
    try { d.show(); } catch (_) {}
    if (withRefresh) refreshDrawer();
  }

  /* התבנית מודיעה שהוספה הצליחה — לוודא שהמגירה באוויר */
  document.addEventListener('product-ajax:added', function () {
    setTimeout(function () { ensureDrawerOpen(false); }, 120);
  });

  /* אירועי פתיחה גנריים (אינטגרציות) */
  ['cart:open', 'theme:cart:open'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(function () { ensureDrawerOpen(false); }, 50);
    });
  });

  /* רשת אחרונה: שליחת טופס מוצר. אם 900ms אחרי — עדיין סגורה,
     סימן שהזרימה של התבנית נפלה בדרך: פותחים ומרעננים תוכן. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[is="product-form"]')) return;
    var d = getDrawer();
    if (d && d.contains(f)) return; /* לא טפסים בתוך העגלה */
    setTimeout(function () { ensureDrawerOpen(true); }, 900);
  }, true);

  /* ───────── שומר-סף לסגירה ─────────
     הסגירה של Sleek ממתינה ל-transitionend מהרקע ורק אז משחררת
     את נעילת הגלילה (body.modal-show). אם המעבר בוטל — היא נתקעת
     "באמצע סגירה" לנצח. אנחנו לא נלחמים בה אלא משלימים אותה:
     1) המגירה עדיין פתוחה → hide() של התבנית.
     2) open ירד אבל hidden לא הגיע → משגרים את ה-transitionend
        החסר, ומכונת המצבים של התבנית מסיימת את עצמה כראוי.
     3) רשת אחרונה: modal-show על הגוף בלי אף מודאל פתוח → מוסר. */

  function unstickScrollLock() {
    var d = getDrawer();
    if (d) {
      if (d.hasAttribute('open')) {
        if (typeof d.hide === 'function') d.hide();
        return;
      }
      if (!d.hidden) {
        var ov = d.querySelector('.fixed-overlay');
        if (ov) ov.dispatchEvent(new Event('transitionend'));
      }
    }
    setTimeout(function () {
      var anyOpen = document.querySelector(
        'cart-drawer[open], drawer-component[open], modal-component[open], basic-modal[open], ' +
        'quick-view-modal[open], calculate-shipping[open], search-drawer[open], menu-drawer[open]'
      );
      if (!anyOpen) {
        document.body.classList.remove('modal-show', 'modal-showing');
      }
    }, 320);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var closer = e.target.closest('.cart-drawer .drawer__close-btn, .cart-drawer .fixed-overlay');
    if (!closer) return;
    setTimeout(unstickScrollLock, 700);
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') setTimeout(unstickScrollLock, 700);
  });

  /* חזרה לדף מה-bfcache עם נעילה תקועה — מנקים */
  window.addEventListener('pageshow', function () {
    setTimeout(unstickScrollLock, 60);
  });

  /* ───────── מנוע כמות עצמאי — אופטימי ומהיר ─────────
     משתלט מלא על +/− (capture) כדי שה-JS של התבנית לא יתחרה בנו:
     המספר מתעדכן מיידית, לחיצות רצופות נאספות לבקשת שרת אחת. */

  var qtyTimers = {};

  function commitQty(line, qty) {
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () {
      cartChangeLine(line, qty)
        .then(refreshDrawer)
        .catch(function () { refreshDrawer(); });
    }, 350);
  }

  /* תווית נגישות למינוס: "הפחתה" כשכמות > 1, "הסרה" כשהוא פח */
  function syncMinusLabels() {
    document.querySelectorAll('.cart-drawer quantity-input.ids-qty').forEach(function (qi) {
      var minus = qi.querySelector('.quantity__button[name="minus"]');
      if (!minus) return;
      var q = Number(qi.getAttribute('data-qty')) || 1;
      minus.setAttribute('aria-label', q <= 1 ? '\u05D4\u05E1\u05E8\u05EA \u05D4\u05E4\u05E8\u05D9\u05D8 \u05DE\u05D4\u05E1\u05DC' : '\u05D4\u05E4\u05D7\u05EA\u05EA \u05DB\u05DE\u05D5\u05EA'); /* הסרת הפריט מהסל / הפחתת כמות */
    });
  }

  function stepQty(btn, dir) {
    var qi = btn.closest('quantity-input');
    var input = qi ? qi.querySelector('.quantity__input') : null;
    if (!input) return;
    var line = input.getAttribute('data-index');
    if (!line) return;
    var step = Number(input.getAttribute('step')) || 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? Number(maxAttr) : Infinity;
    var cur = Number(input.value) || 1;
    var next = dir > 0 ? Math.min(cur + step, max) : cur - step;

    if (next < 1) {
      /* פח — מחיקת השורה */
      var li = btn.closest('.cart-item');
      if (li) li.classList.add('is-updating');
      clearTimeout(qtyTimers[line]);
      cartChangeLine(line, 0)
        .then(refreshDrawer)
        .catch(function () { refreshDrawer(); });
      return;
    }
    if (next === cur) return;

    /* אופטימי: המסך מתעדכן מיד, השרת מתעדכן אחרי שנייה של שקט */
    input.value = next;
    qi.setAttribute('data-qty', next);
    var item = btn.closest('.cart-item');
    if (item) {
      item.setAttribute('data-quantity', next);
      item.classList.add('is-updating');
    }
    syncMinusLabels();
    commitQty(line, next);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.cart-drawer quantity-input.ids-qty .quantity__button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    stepQty(btn, btn.getAttribute('name') === 'plus' ? 1 : -1);
  }, true);

  /* הקלדה ידנית של כמות */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var input = e.target.closest('.cart-drawer quantity-input.ids-qty .quantity__input');
    if (!input) return;
    e.stopPropagation();
    var line = input.getAttribute('data-index');
    if (!line) return;
    var qty = Math.max(0, Math.floor(Number(input.value) || 0));
    var qi = input.closest('quantity-input');
    var item = input.closest('.cart-item');
    if (item) item.classList.add('is-updating');
    if (qi && qty > 0) qi.setAttribute('data-qty', qty);
    commitQty(line, qty);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t;

    t = e.target.closest('[data-ids-coupon-toggle]');
    if (t) { toggleCoupon(t); return; }

    t = e.target.closest('[data-ids-coupon-apply]');
    if (t) { applyCoupon(t); return; }

    t = e.target.closest('[data-ids-coupon-remove]');
    if (t) { removeCoupon(t); return; }

    t = e.target.closest('[data-ids-gift-add]');
    if (t) { addGift(t, t.getAttribute('data-ids-gift-add')); return; }

    t = e.target.closest('[data-ids-gift-change]');
    if (t) { openGiftSwap(t); return; }

    t = e.target.closest('[data-ids-gift-keep]');
    if (t) { closeGiftSwap(t); return; }

    t = e.target.closest('[data-ids-gift-swap]');
    if (t) { swapGift(t, t.getAttribute('data-ids-gift-swap')); return; }

    t = e.target.closest('[data-ids-upsell-add]');
    if (t) { addUpsell(t); return; }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var sel = e.target.closest('[data-ids-line-variant]');
    if (sel) { swapLineVariant(sel); return; }
    var usel = e.target.closest('[data-ids-upsell-variant]');
    if (usel) {
      usel.classList.remove('ids-sel-invalid');
      /* בחירת מידה = הוספה לסל. פעולה אחת במקום שתיים */
      if (usel.value) {
        var uitem = usel.closest('.ids-upsell__item');
        var ubtn = uitem ? uitem.querySelector('[data-ids-upsell-add]') : null;
        if (ubtn) setBusy(ubtn, true);
        usel.disabled = true; /* מניעת שיגור כפול עד הרענון */
        setDrawerBusy(true);
        cartAdd(usel.value, 1)
          .then(refreshDrawer)
          .catch(function () { refreshDrawer(); });
      }
      return;
    }
    if (box) { onTermsChange(box); }
  });


  /* ───────── אתחול + שרידות לרינדורים של התבנית ───────── */

  function init() {
    loadUpsell();
    handleOrphanGift();
    syncMinusLabels();
    attachObserver();
  }

  function scheduleInit() {
    clearTimeout(initTimer);
    initTimer = setTimeout(init, 120);
  }

  function attachObserver() {
    var d = getDrawer();
    if (!d || d.getAttribute('data-ids-observed') === '1') return;
    d.setAttribute('data-ids-observed', '1');
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () { scheduleInit(); });
    observer.observe(d, { childList: true, subtree: true });
  }

  /* כשהתבנית מרעננת את הסל בעצמה (כמות/מחיקה/הוספה מבחוץ) */
  ['cart:refresh', 'cart:updated', 'on:cart:add', 'ajaxCart:added', 'fc:cart:added'
  ].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (e && e.detail && e.detail.source === 'ids-cart-extras') return;
      scheduleInit();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();